module.exports = __webpack_public_path__ + "img/g_mro_9.c0333394.png";